import { render, staticRenderFns } from "./InnerIframeItem.vue?vue&type=template&id=4b1413d4&scoped=true"
import script from "./InnerIframeItem.vue?vue&type=script&lang=js"
export * from "./InnerIframeItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1413d4",
  null
  
)

export default component.exports